/**
 * InfinitSales - Inbox do Instagram Direct
 *
 * Wrapper fino sobre o shell COMPARTILHADO do inbox
 * (components/inbox/Inbox.jsx): toda a fiacao do canal mora no adaptador
 * (components/inbox/channelAdapters/instagram.js). Extraido em 2026-09-23
 * (fase 4 do inbox do widget); antes este arquivo tinha 949 linhas clonadas
 * do wa-business.
 */
import React from 'react';
import ChannelInbox from '../../components/inbox/Inbox';
import instagramAdapter from '../../components/inbox/channelAdapters/instagram';

const InstagramInbox = () => <ChannelInbox adapter={instagramAdapter} />;

export default InstagramInbox;
